var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "inn" }, [
        _vm.type == "gif"
          ? _c("img", {
              style: { width: _vm.wid, height: _vm.hig },
              attrs: { src: _vm.url + "?_" + Date.now() }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type == "img"
          ? _c("img", {
              style: { width: _vm.wid, height: _vm.hig },
              attrs: { src: _vm.url }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type == "video"
          ? _c("video", { attrs: { src: _vm.url, controls: "" } })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "close", on: { click: _vm.close } }, [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.url.length > 0,
                expression: "url.length > 0"
              }
            ],
            attrs: { src: require("../../assets/cloe.png") }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54f3af3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f3af3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/bImg.vue
// module id = null
// module chunks = 